import React, { ForwardedRef } from 'react';
import { ButtonStyled } from './styles';

type Props = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  label?: string;
};

function Button({ label, ...props }: Props, ref: ForwardedRef<HTMLButtonElement>) {
  return (
    <ButtonStyled {...props} ref={ref}>
      {label ? <span>{label}</span> : props.children && props.children}
    </ButtonStyled>
  );
}

export default React.forwardRef(Button);
